__turbopack_context__.v({
  "input": "-knnsq_input",
  "label": "-knnsq_label",
  "label--elevated": "-knnsq_label--elevated",
  "leadingIcon": "-knnsq_leadingIcon",
  "root": "-knnsq_root",
  "trailingIcon": "-knnsq_trailingIcon",
  "wrapper": "-knnsq_wrapper",
  "wrapper--disabled": "-knnsq_wrapper--disabled",
  "wrapper--error": "-knnsq_wrapper--error",
  "wrapper--focused": "-knnsq_wrapper--focused",
  "wrapper--leading": "-knnsq_wrapper--leading",
  "wrapper--trailing": "-knnsq_wrapper--trailing",
});
